import React, { useState } from "react";
import { Formik, Form, yupToFormErrors } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { retailVoiceSchema } from "./voiceAddSchema";
import { useDispatch, useSelector } from "react-redux";
import SpinnerComponent from "../spinner/spinner";
import { store } from "../../redux/storeConfig/store";
import {
  createProduct,
  editGym,
  getGymCategories,
  updateProduct,
} from "../../redux/actions/api/apiAction";
import { StepButtonForProduct } from "./stepButtonForProduct";
import moment from "moment";
import Swal from "sweetalert2";
import { saveVoiceDraftEdit } from "../voiceAdd/saveDraftEdit";
import { withVoicePrefill } from "../voiceAdd/openForm";

// export const MultiStep = () => {
function MultiStepForRetail({
  name,
  type,
  price,
  tax,
  cost,
  barcode,
  category,
  stock,
  minInStock,
  supplier,
  expiryDate,
  note,
  handleSubmit,
  measureOfPurchase,
  measureOfUnit,
  weight,
  productType,
  weightUnit,
  purchasedPrice,
}) {
  const [step, setStep] = useState(1);
  const { gym, categories } = useSelector((state) => state.gym);
  const { product } = useSelector((state) => state.product);
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(getGymCategories());
  }, []);
  handleSubmit = async (values) => {
    if (saveVoiceDraftEdit(values)) return;
    console.log({ values });
    Swal.fire({
      title: "Confirm",
      text: "Are you sure you want to create this product?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#4D4467",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, create it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        console.log({ values });
        let payload = {
          ...values,
          payrateId:
            values?.payRates && values?.payRates.length
              ? values.payRates[0].id
              : null,
          cost: values.stock * values.purchasedPrice,
          purchasedPrice: values.purchasedPrice,
          netPrice: values.price,
          expiryDate: values?.expiryDate
            ? moment(values?.expiryDate).valueOf()
            : null,
          existingCategories: categories ? categories : [],
        };
        await store.dispatch(createProduct(payload));
      }
    });
  };

  const submit = (values) => {
    handleSubmit(values);
  };

  const previous = () => setStep((step) => step - 1);

  const formSchema1 = retailVoiceSchema;

  const { loading } = useSelector((state) => state.gym);
  if (loading)
    return (
      <div
        style={{ height: "800px" }}
        className="d-flex flex-column align-items-center justify-content-center"
      >
        <SpinnerComponent />
        <h3>Please wait</h3>
      </div>
    );

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={withVoicePrefill("product", {
          name,
          type,
          price,
          tax,
          cost,
          barcode,
          category,
          stock,
          supplier,
          expiryDate,
          note,
          measureOfPurchase,
          measureOfUnit,
          minInStock,
          weight,
          productType,
          purchasedPrice,
          weightUnit,
        })}
        onSubmit={submit}
        validationSchema={formSchema1}
      >
        {({ errors, touched, values, setFieldValue,handleChange }) => (
          <Form>
            <FormFirstStep
              errors={errors}
              touched={touched}
              values={values}
              setFieldValue={setFieldValue}
              handleChange={handleChange}
            />

            <StepButtonForProduct step={step} previous={previous} />
          </Form>
        )}
      </Formik>
    </>
  );
}
MultiStepForRetail.defaultProps = {
  name: "",
  type: "",
  price: 0,
  tax: 0,
  cost: 0,
  barcode: "",
  category: "",
  stock: 0,
  minInStock: 0,
  supplier: "",
  expiryDate: null,
  measureOfPurchase: "",
  measureOfUnit: "",
  productType: "S",
  weight: "",
  note: "",
  edit: false,
  weightUnit: "",
  purchasedPrice: 0,
};

export default MultiStepForRetail;
